import React, { memo } from "react";
import parse from "html-react-parser";
const HTMLParser = (props) => {
    if (props.children && props.children.length) {
        return React.createElement(React.Fragment, null, parse(props.children));
    }
    return React.createElement(React.Fragment, null);
};
export default memo(HTMLParser);
